import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { AlbumPayloadItem } from 'APP/main/ChatView/Messages/Message/Payload/Album/AlbumPayloadItem/AlbumPayloadItem';
import { ChatMessage } from 'STORE/Messages/Message/ChatMessage/ChatMessage';

import { useAlbumPresenter } from './Album.presenter';
import styles from './Album.styles.m.css';

interface IAlbumProps {
  message: ChatMessage;
  isPreview: boolean;
  isView: boolean;
}

export const Album: FC<IAlbumProps> = observer(({ message, isPreview, isView }) => {
  const presenter = useAlbumPresenter({ message });

  return (
    <div className={styles.container}>
      {presenter.layout.map((row) => (
        <div
          key={row.id}
          className={styles.row}
        >
          {row.items.map((item) => {
            const payload = presenter.getPayload(item.id);

            return (
              <div
                key={item.id}
                className={styles.itemContainer}
                style={{ width: `${item.containerWidth}%` }}
              >
                <div style={{ paddingBottom: `${item.containerRatio * 100}%` }} />
                <AlbumPayloadItem
                  id={payload.id}
                  payload={payload.payload}
                  isLoading={message.isFake}
                  isPreview={isPreview}
                  isView={isView}
                  isFromMe={presenter.isFromMe}
                  openGallery={presenter.openMediaGallery}
                  groupId={message.groupId}
                  messageId={message.id}
                  hasError={message.hasError}
                  payloadId={payload.id}
                />
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
});
